export function initSideNav() {
  if (!document.querySelector('.hero')) return;

  const DEFAULT_SECTIONS = [
    { label: 'Miért a DiBO?',   short: 'Miért?',     href: '#pillerek' },
    { label: 'Csomagjaink',     short: 'Csomagok',   href: '#gold' },
    { label: 'Befektetőknek',   short: 'Befektetés', href: '#befektetoknek' },
    { label: 'Ajánlatkérés',    short: 'Ajánlat',    href: '#ajanlatkeres' },
  ];

  const configured = window.DiboSite && window.DiboSite.sideNav;
  const SOURCE = Array.isArray(configured) && configured.length ? configured : DEFAULT_SECTIONS;

  const SECTIONS = SOURCE.map(s => ({
    label: s.label || '',
    short: s.short || s.label || '',
    href: s.href,
    getEl: () => (s.href && typeof s.href === 'string' ? document.getElementById(s.href.replace('#', '')) : null),
  }));

  const resolved = SECTIONS.map(s => ({ ...s, target: s.getEl() })).filter(s => s.target);
  if (resolved.length < 2) return;

  // Build nav
  const nav = document.createElement('nav');
  nav.className = 'side-nav';
  nav.setAttribute('aria-hidden', 'true');

  const list = document.createElement('ul');
  list.className = 'side-nav__list';

  const indicator = document.createElement('span');
  indicator.className = 'side-nav__indicator';
  indicator.setAttribute('aria-hidden', 'true');

  const items = resolved.map(({ label, short, href, target }) => {
    const li = document.createElement('li');
    li.className = 'side-nav__item';

    const a = document.createElement('a');
    a.href = href;
    a.className = 'side-nav__link';
    a.tabIndex = -1;

    const labelSpan = document.createElement('span');
    labelSpan.className = 'side-nav__label';
    labelSpan.textContent = label;

    const shortSpan = document.createElement('span');
    shortSpan.className = 'side-nav__label-short';
    shortSpan.textContent = short;

    a.appendChild(labelSpan);
    a.appendChild(shortSpan);
    li.appendChild(a);

    a.addEventListener('click', e => {
      e.preventDefault();
      if (target.getBoundingClientRect().height > 0) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
    list.appendChild(li);
    return li;
  });

  nav.appendChild(indicator);
  nav.appendChild(list);
  document.body.appendChild(nav);

  let activeIdx = -1;
  let rafId = null;

  // Only reveal the nav once the "4 pillér" section is reached.
  const revealAt = resolved[0].target;

  function updateVisibility() {
    const rect = revealAt.getBoundingClientRect();
    // #pillerek is hidden on mobile (display:none → height/width = 0),
    // so fall back to a scroll-past-hero threshold in that case.
    const isHidden = rect.height === 0 && rect.width === 0;
    if (isHidden) {
      nav.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.6);
    } else {
      nav.classList.toggle('is-visible', rect.top <= window.innerHeight * 0.5);
    }
  }

  function findActive() {
    const mid = window.innerHeight / 2;
    let best = 0;
    let bestDist = Infinity;
    resolved.forEach(({ target }, i) => {
      const rect = target.getBoundingClientRect();
      if (rect.height === 0) return; // skip hidden elements (e.g. display:none on mobile)
      const center = rect.top + rect.height / 2;
      const dist = Math.abs(center - mid);
      if (dist < bestDist) { bestDist = dist; best = i; }
    });
    return best;
  }

  function applyActive() {
    list.style.transform = '';
    const active = items[activeIdx];
    const shrink = window.innerWidth > 980 ? 30 : 0;
    indicator.style.transform = `translateX(${active.offsetLeft + shrink / 2}px)`;
    indicator.style.width = `${active.offsetWidth - shrink}px`;
    items.forEach((item, i) => {
      item.classList.toggle('is-active', i === activeIdx);
    });
  }

  function render() {
    updateVisibility();
    const next = findActive();
    if (next === activeIdx) return;
    activeIdx = next;
    applyActive();
  }

  function onScroll() {
    if (rafId) return;
    rafId = requestAnimationFrame(() => { render(); rafId = null; });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  // Re-apply on resize: the indicator's offsetLeft/Width change with the viewport width.
  window.addEventListener('resize', () => { if (activeIdx >= 0) applyActive(); }, { passive: true });
  render();
}
